import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'KeyValueDiff',
  props: {
    changes: null,
    keyLabels: null
  },
  setup: function setup(__props) {
    var props = __props;
    var changes = computed(function () {
      var _props$changes;
      return (_props$changes = props.changes) !== null && _props$changes !== void 0 ? _props$changes : [];
    });
    function formatKey(key) {
      var _props$keyLabels$key, _props$keyLabels;
      return (_props$keyLabels$key = (_props$keyLabels = props.keyLabels) === null || _props$keyLabels === void 0 ? void 0 : _props$keyLabels[key]) !== null && _props$keyLabels$key !== void 0 ? _props$keyLabels$key : key;
    }
    function formatValue(value) {
      if (value === null || value === undefined) return '—';
      return String(value);
    }
    return {
      __sfc: true,
      props: props,
      changes: changes,
      formatKey: formatKey,
      formatValue: formatValue
    };
  }
});